export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";